import { LandingContent } from "./types";
import {
  GiWeightLiftingUp,
  GiGymBag,
  GiStopwatch,
  GiNotebook,
  GiChatBubble,
} from "react-icons/gi";
import { FaQuestion } from "react-icons/fa";
import gymImage from "../../assets/images/gym.jpg"

export const gymContent: LandingContent = {
  seo: {
    title: "Edzőtermek és oktatók online időpontfoglaló | Wobble",
    description:
      "Egyszerű és gyors online időpontfoglaló rendszer edzőtermeknek, személyi edzőknek, csoportos órákat tartó oktatóknak és jógastúdióknak. Próbáld ki a Wobble-t ingyen!",
    ogTitle: "Wobble - Edzőtermek és oktatók időpontfoglaló rendszere",
    ogDescription:
      "Spórolj időt és növeld a bevételeid! Kezeld az órarendet, vendégeket és kommunikációt egyetlen felületen.",
    keywords: "edzőterem, személyi edző, jóga, pilates, időpontfoglalás, online foglalás, Wobble",
    image: "../assets/mockup_moov_studio.png"
  },
  header: {
    heading: "Modern időpontfoglalás edzőtermeknek és oktatóknak",
    subheading:
      "Kezeld egyszerűen az órarended, foglalásokat és ügyfeleid — legyen szó személyi edzésről, csoportos fitneszről, pilatesről, gyógytornáról vagy jógáról.",
    highlightText: "Wobble időpontfoglaló rendszer edzőknek és termeknek",
  },
  problems: {
    title: "Ismerős problémák?",
    features: [
      { icon: GiNotebook, text: "Órák adminisztrációja táblázatokban vagy papíron?" },
      { icon: GiChatBubble, text: "Nehézkes lemondások és kommunikáció a vendégekkel?" },
      { icon: GiStopwatch, text: "Sok időt visz el a foglalások kezelése, ügyfelek visszahívása?" },
      { icon: FaQuestion, text: "Visszatérő kérdések, e-mailek és hívások megválaszolása terhel?" },
      { icon: GiGymBag, text: "Több edző vagy terem beosztását szeretnéd egyszerűen kezelni?" },
    ],
    summaryText:
      "Automatizálj a Wobble-lel, és fókuszálj az edzésre - az adminisztrációt bízd ránk!",
    cta: {
      href: "https://app.wobble.hu/signup_page",
      label: "Kipróbálom ingyen",
    },
    imageSrc: gymImage,
    imageAlt: "Edző időpontfoglalás",
  },
  whyDigitalize: {
    title: "Miért érdemes digitalizálni?",
    features: [
      { icon: GiWeightLiftingUp, text: "A vendégek online keresnek órát és foglalnak időpontot" },
      { icon: GiStopwatch, text: "A foglalás bármikor elérhető, még éjjel is" },
      { icon: GiChatBubble, text: "Automatikus emlékeztetők csökkentik a mulasztást" },
      { icon: GiNotebook, text: "Könnyen nyomon követhető foglalások, ügyfelek és órák" },
      { icon: GiGymBag, text: "Rugalmas beállítások: egyéni és csoportos foglalás, helyszín, oktató, felszerelés beállítása" },
    ],
  },
  whyTheyLove: {
    title: "Hogyan könnyíti meg a munkád a Wobble?",
    imageSrc: "../assets/mockup_moov_studio.png",
    imageAlt: "Edzőtermi időpontfoglalás",
    features: [
      { icon: GiWeightLiftingUp, text: "Egyedi foglalási rendszer percek alatt" },
      { icon: GiGymBag, text: "Oktatók, órák és termek kezelése egy felületen" },
      { icon: GiStopwatch, text: "Automatikus visszaigazolás és emlékeztető" },
      { icon: GiChatBubble, text: "Kérdőíves ügyféladat bekérés foglaláskor" },
      { icon: GiNotebook, text: "Egyszerű adminisztráció és nyilvántartás, felesleges telefonásál nélkül" },
    ],
  },
  trial: {
    title: "💪 Csatlakozz most",
    title2: "30 nap ingyenes próbaidőszak!",
    subtitle: "Próbáld ki a Wobble-t kockázat nélkül - nincs szükség kártyaadatra.",
    cta: {
      href: "https://app.wobble.hu/signup_page",
      label: "Regisztrálok most",
    },
  },
};
